import { TFunction } from 'i18next';

/** Resolve map-import label keys via shared namespaces after label consolidation. */
const MAP_IMPORT_LABEL_FALLBACKS: Record<string, string> = {
  totalAmount: 'transactions.gross',
  country: 'common.country',
  name: 'common.name',
  description: 'common.description',
  currency: 'common.currency',
  transactionDate: 'transactions.transactionDate',
  dueDate: 'main.dueDate',
  sourceType: 'exceptions.sourceType',
  reference: 'organisation.reference',
  netAmount: 'exceptions.netAmount',
  taxName: 'transactions.taxName',
  taxRate: 'transactions.taxRate',
  isCustomerSupplier: 'vat-checker.type',
  accountCode: 'transactions.accountCode',
  accountType: 'organisation.account-type',
  uploadDate: 'transactions.upload-date',
  taxInclusive: 'transactions.taxInclusive',
};

export function getMapImportFieldLabel(
  tooltipKey: string,
  t: TFunction
): string {
  return tryGetMapImportFieldLabel(tooltipKey, t) ?? tooltipKey;
}

export function tryGetMapImportFieldLabel(
  tooltipKey: string,
  t: TFunction
): string | undefined {
  const fallbackKey = MAP_IMPORT_LABEL_FALLBACKS[tooltipKey];
  if (fallbackKey) {
    const fallbackLabel = t(fallbackKey);
    if (fallbackLabel !== fallbackKey) {
      return fallbackLabel;
    }
  }
  const mapKey = `mapImportFields.labels.${tooltipKey}`;
  const mapLabel = t(mapKey);
  return mapLabel !== mapKey ? mapLabel : undefined;
}
